import type { ReactNode } from "react"
import { createContext, useContext } from "react"

export interface ImageViewerHostValue {
	container?: HTMLElement | null
	compact?: boolean
	onOpen?: () => void
	onClose?: () => void
}

const ImageViewerHostContext = createContext<ImageViewerHostValue | null>(null)

export function ImageViewerHostProvider({
	value,
	children,
}: {
	value: ImageViewerHostValue
	children: ReactNode
}) {
	return (
		<ImageViewerHostContext.Provider value={value}>
			{children}
		</ImageViewerHostContext.Provider>
	)
}

export function useImageViewerHost(): ImageViewerHostValue | null {
	return useContext(ImageViewerHostContext)
}
